import React from 'react';
import i18n from '../../locales/i18n';
import styles from './LanguageSwitcher.module.scss';

const SUPPORTED_LANGS = ['is', 'en'];

/**
 * Pill-shaped language switcher. Shows the supported languages as toggle
 * buttons (IS / EN). Clicking a language updates i18n, persists the choice
 * to localStorage and keeps <html lang> in sync via the languageChanged
 * listener in src/locales/i18n.js.
 *
 * Pass a `size` prop ("md" default, or "sm" for compact placements such as
 * inside the sidebar footer beside the logout button).
 */
const LanguageSwitcher = ({ size = 'md', className = '' }) => {
    // i18n.changeLanguage triggers a re-render through withTranslation/
    // useTranslation consumers, so reading i18n.language here is safe to
    // derive the current selection on each render.
    const current = SUPPORTED_LANGS.includes(i18n.language) ? i18n.language : 'is';

    const handleChange = (lng) => {
        if (lng === current) return;
        i18n.changeLanguage(lng);
        try {
            localStorage.setItem('lang', lng);
        } catch {
            // localStorage may be unavailable (private mode, SSR); ignore.
        }
    };

    return (
        <div
            className={`${styles.langSwitcher} ${styles[`size_${size}`]} ${className}`}
            role="group"
            aria-label="Language"
        >
            {SUPPORTED_LANGS.map((lng) => (
                <button
                    key={lng}
                    type="button"
                    translate="no"
                    className={`${styles.langBtn} ${current === lng ? styles.langBtnActive : ''}`}
                    onClick={() => handleChange(lng)}
                    aria-pressed={current === lng}
                >
                    {lng.toUpperCase()}
                </button>
            ))}
        </div>
    );
};

export default LanguageSwitcher;
